import { render, staticRenderFns } from "./PhysicalClub.vue?vue&type=template&id=0409c14d&"
import script from "./PhysicalClub.vue?vue&type=script&lang=js&"
export * from "./PhysicalClub.vue?vue&type=script&lang=js&"
import style0 from "./PhysicalClub.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports